import { routes } from './entities.routes';
import LmeListEntitiesController from "./directory/directory.controller";
import LmeDetailsEntitiesController from "./details/details.controller";
export default angular.module('app.lab.entities', [])
    .config(routes)
    .controller('LmeListEntitiesController', LmeListEntitiesController)
    .controller('LmeDetailsEntitiesController', LmeDetailsEntitiesController)
    .name;
